/**
 * Foil Filter
 * Filters products based on variant titles containing "foil"
 */

class FoilFilter {
  constructor() {
    this.filterSelect = document.getElementById('FoilFilter');
    this.productCards = [];

    if (!this.filterSelect) return;

    this.init();
  }

  init() {
    // Load saved filter preference
    const savedFilter = sessionStorage.getItem('foil-filter-preference');
    if (savedFilter) {
      this.filterSelect.value = savedFilter;
      this.applyFilter(savedFilter);
    }

    // Listen for filter changes
    this.filterSelect.addEventListener('change', (e) => {
      const filterValue = e.target.value;
      sessionStorage.setItem('foil-filter-preference', filterValue);
      this.applyFilter(filterValue);
    });

    // Re-apply filter after AJAX content updates
    document.addEventListener('collectionProductsLoaded', () => {
      const currentFilter = this.filterSelect.value;
      if (currentFilter !== 'all') {
        this.applyFilter(currentFilter);
      }
    });
  }

  applyFilter(filterValue) {
    // Get all product cards
    this.productCards = document.querySelectorAll('.collection-product-card');

    if (filterValue === 'all') {
      // Show all products
      this.productCards.forEach(card => {
        card.style.display = '';
        const gridItem = card.closest('.grid__item');
        if (gridItem) gridItem.style.display = '';
      });
      return;
    }

    // Filter products based on variant titles
    this.productCards.forEach(card => {
      const hasFoilVariant = this.checkForFoilVariants(card);
      const shouldShow = (filterValue === 'foil' && hasFoilVariant) ||
                        (filterValue === 'normal' && !hasFoilVariant);

      if (shouldShow) {
        card.style.display = '';
        const gridItem = card.closest('.grid__item');
        if (gridItem) gridItem.style.display = '';
      } else {
        card.style.display = 'none';
        const gridItem = card.closest('.grid__item');
        if (gridItem) gridItem.style.display = 'none';
      }
    });
  }

  checkForFoilVariants(card) {
    // Check if any in-stock variant has "foil" in the title
    const variantSelect = card.querySelector('.collection-variant-select');

    if (variantSelect) {
      // Check dropdown options
      const options = variantSelect.querySelectorAll('option');
      for (let option of options) {
        const variantTitle = option.textContent.toLowerCase();
        if (variantTitle.includes('foil')) {
          return true;
        }
      }
    } else {
      // Check single variant display
      const variantDisplay = card.querySelector('.collection-variant-display');
      if (variantDisplay) {
        const variantTitle = variantDisplay.textContent.toLowerCase();
        if (variantTitle.includes('foil')) {
          return true;
        }
      }
    }

    return false;
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.foilFilter = new FoilFilter();
  });
} else {
  window.foilFilter = new FoilFilter();
}
